import RecentInspections from './RecentInspections';
import { useSoloInspection } from '../../hooks/useSoloInspection';
import InspectionTab, { COUNCIL_MODELS_SOLO } from './InspectionTab';

// «ارتش تک نفره» container. Reuses the parameterized InspectionTab with a
// 1-member roster and both stage 2 (peer review) and stage 3
// (chairman) hidden - there's nothing to peer-review and no one to chair.
// The single model card carries the whole inspection.
export default function SoloInspectionTabContainer({ slots, concealModelIdentities }) {
  const props = useSoloInspection({ slots, concealModelIdentities });
  return (
    <>
      <InspectionTab
        {...props}
        councilModels={COUNCIL_MODELS_SOLO}
        showStage2={false}
        showStage3={false}
      />
      <RecentInspections variant="solo" finishedRun={props.finalVerdict || props.error} />
    </>
  );
}
